import { useMemo } from 'react';
import { snakeCase } from 'lodash';

import { PROJECTS_CATEGORIES_VIEWS } from 'src/data/project';
import {
  BlogWizardIcon,
  DocumentsIcon,
  Performance,
  BrandVoiceIcon,
  IntegrationsResourcesIcon,
} from 'src/assets/icons/navbar-links';
import { ROUTES } from 'src/routes';
import { ITEM_TYPE } from '../const';

const createLinkItem = ({ label, path, icon, style }) => ({
  type: ITEM_TYPE.link,
  id: path,
  label,
  path,
  icon,
  style,
});

const createSubmenuItem = ({ label, icon, items, style }) => ({
  type: ITEM_TYPE.submenu,
  id: `submenu_${snakeCase(label)}`,
  label,
  icon,
  items,
});

export const useNavigationSidebarItems = () => {
  return useMemo(
    () => [
      createLinkItem({
        label: 'Editor',
        path: `${ROUTES.PROJECTS}?category=${PROJECTS_CATEGORIES_VIEWS.documentEditor}`,
        icon: DocumentsIcon,
      }),
      createLinkItem({
        label: 'Blog Wizard',
        path: `${ROUTES.PROJECTS}?category=${PROJECTS_CATEGORIES_VIEWS.blog}`,
        icon: BlogWizardIcon,
      }),

      createSubmenuItem({
        label: 'Copy Intelligence',
        icon: Performance,
        items: [
          createLinkItem({
            label: 'Analytics',
            path: ROUTES.ANALYTICS,
          }),
          createLinkItem({
            label: 'Talking Points',
            path: ROUTES.TALKING_POINTS,
          }),
          createLinkItem({
            label: 'Custom Models',
            path: ROUTES.CUSTOM_MODELS,
          }),
          createLinkItem({
            label: 'Website Automation',
            path: ROUTES.WEBSITE_AUTOMATION,
          }),
        ],
      }),

      createSubmenuItem({
        label: 'Brand Voice',
        icon: BrandVoiceIcon,
        items: [
          createLinkItem({
            label: 'Tone of Voice',
            path: ROUTES.TONE_OF_VOICE,
          }),
          createLinkItem({
            label: 'Target Audiences',
            path: ROUTES.PERSONAS,
          }),
          createLinkItem({
            label: 'Messaging Bank',
            path: ROUTES.BRAND_BRIEFS,
          }),
          createLinkItem({
            label: 'Prompts & Formulas',
            path: ROUTES.CUSTOM_FORMULAS,
          }),
          createLinkItem({
            label: 'Brand Rules',
            path: ROUTES.BRAND_GUIDELINES,
          }),
        ],
      }),

      createLinkItem({
        label: 'Integrations & Resources',
        path: ROUTES.INTEGRATIONS_RESOURCES,
        icon: IntegrationsResourcesIcon,
      }),
    ],
    []
  );
};
